export default __webpack_public_path__ + "static/pic3-e2335f64c21a527b75ac928f07a79031.jpg";